import React, {useContext, useEffect, useState} from "react";
import PropTypes from 'prop-types'
import {Button, Dialog, DialogActions, DialogContent} from "@material-ui/core";
import {set, insert, del} from 'object-path-immutable';
import {makeStyles} from '@material-ui/core/styles';
import ActionForm from "./ActionForm/ActionForm";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import SelectWebEvent from "./ActionForm/SelectWebEvent";
import {generateFunctionReference} from "../../../../../../../JsonScreen/Utils/lib";
import ShortcutInput from "./ActionForm/ShortcutInput";

const useStyles = makeStyles(() => ({
    dialogContentRoot: {
        '&:first-child': {
            paddingTop: 0
        }
    },
    dialogContent: {
        padding: 5,
    },
    paperWidthSm: {
        maxWidth: 750
    }
}));
const emptyParam = {param: [{}]};

const Actions = ({open, onClose, eventIndex, schema, onChangeEventComponent}) => {
    const {
        screenValues: {script, version: designerVersion},
        selectedComponent: {component: {id, type: componentType, properties: {path} = {}, events = []} = {}},
        actionSave
    } = useContext(ScreenDesignerContextNew);
    const [actions, setActions] = useState(null);
    const [eventType, setEventType] = useState(null);
    const classes = useStyles();

    useEffect(() => {
        if (eventIndex !== null) {
            if (events.length && events[eventIndex]) {
                const eventActions = events[eventIndex].actions;
                const event = events[eventIndex].event;

                if (designerVersion === 3) {
                    if (eventActions && eventActions.length) {
                        let executeFnIndex = eventActions.findIndex(a => a.type === 'executeJs');
                        if (executeFnIndex !== -1) {
                            const fnName = componentType === 'field' ?
                                generateFunctionReference(`${path}_${id}`, event) :
                                generateFunctionReference(id, event);

                            const startMarker = `//->${fnName}`;
                            const endMarker = `//<-${fnName}`;

                            const regex = new RegExp(`${startMarker}([\\s\\S]*?)${endMarker}`)
                            const match = script?.match(regex);
                            if (match) {
                                const functionCode = match[1].trim();  // Extracted function code
                                let functionBody = functionCode.substring(
                                    functionCode.indexOf("{") + 1,
                                    functionCode.lastIndexOf("}")
                                ).trim();
                                eventActions[executeFnIndex].value = `{\n${functionBody}\n}`
                            } else {
                                console.log("No match found.");
                            }
                        }
                    }
                }

                setActions(eventActions);
                setEventType(event);
                return
            }
            setActions(null);
            setEventType(null);
        }
    }, [eventIndex, JSON.stringify(events)]);

    const createAction = (index) => {
        let newValues = insert(actions, '', emptyParam, index);
        setActions(newValues);
    };
    const removeAction = (index) => {
        let newValues;
        if (actions.length === 1) {
            newValues = set(actions, '0', emptyParam)
        } else {
            newValues = del(actions, `${index}`)
        }
        setActions(newValues)
    };
    const createParam = (actionIndex, index) => {
        const newValues = insert(actions, `${actionIndex}.param`, {}, index);
        setActions(newValues)
    };
    const removeParam = (actionIndex, index) => {
        let newValues;
        if (actions[actionIndex].param.length === 1) {
            newValues = set(actions, `${actionIndex}.param.0`, {})
        } else {
            newValues = del(actions, `${actionIndex}.param.${index}`)
        }
        setActions(newValues)
    };
    const setValue = (value, path) => {
        const newValues = set(actions, path, value);
        setActions(newValues)
    };
    const onKeyDown = (e) => {
        if (e.ctrlKey && e.key === 's') {
            e.preventDefault();
            actionSave(eventIndex, actions);
            onClose();
        }
    };
    return (
        <Dialog
            open={Boolean(open)}
            classes={{paperWidthSm: classes.paperWidthSm}}
            onClose={onClose}
            fullWidth
            maxWidth={"sm"}
            scroll={'paper'}
        >
            <DialogContent
                className={classes.dialogContent}
                classes={{root: classes.dialogContentRoot}}
                onKeyDown={onKeyDown}
            >
                {eventType === 'onKeydown' && (
                    <div style={{padding: 5}}>
                        <ShortcutInput
                            onChangeEventComponent={onChangeEventComponent}
                            eventIndex={eventIndex}
                            events={events}
                        />
                    </div>
                )}
                {eventType === 'onWebEvent' && (
                    <SelectWebEvent
                        onChangeEventComponent={onChangeEventComponent}
                        eventIndex={eventIndex}
                        events={events}
                    />
                )}
                <ActionForm
                    schema={schema}
                    actions={actions}
                    createAction={createAction}
                    removeAction={removeAction}
                    createParam={createParam}
                    removeParam={removeParam}
                    setValue={setValue}
                />
            </DialogContent>
            <DialogActions>
                <div>
                    <Button
                        style={{marginLeft: 5}}
                        onClick={() => {
                            actionSave(eventIndex, actions);
                            onClose();
                        }}
                        size={"small"}
                        color={"primary"}
                        variant={"contained"}>Save</Button>
                    <Button
                        style={{marginLeft: 5}}
                        onClick={onClose}
                        size={"small"}
                        color={"default"}
                        variant={"contained"}>Close</Button>
                </div>
            </DialogActions>
        </Dialog>
    )
};
export default Actions;

Actions.propTypes = {
    open: PropTypes.any,
    onClose: PropTypes.func,
    eventIndex: PropTypes.number,
    schema: PropTypes.array,
    actionSave: PropTypes.func,
    selectedComponent: PropTypes.object,
    onChangeEventComponent: PropTypes.func,
};